/**
 * Initialize $.el8_ajax so we can use it freely
 * in all the el8 libraries
 */
jQuery.el8_ajax = function(options) {
    UIM && UIM.logError('using the old ajax');
    options['jsonp'] = false;
    options['cache'] = true;
    return jQuery.ajax(options);
};

/**
 * Globals available everywhere
 */
KEYS = {
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ENTER: 13,
    TAB: 9,
    BACKSP: 8,
    DELETE: 46,
    PAGEUP: 33,
    PAGEDOWN: 34,
    DASH: 189
};

// String utilities
String.prototype.startswith = function(str) {
	return (this.substr(0,str.length) === str);
};

String.prototype.endswith = function(str) {
    if (!this.length) { return ''; }
	return (this.slice(-1*str.length) === str);
};

String.prototype.toLowerCamel = function() {
    if (!this.length) { return ''; }
    return this.charAt(0).toLowerCase() + this.substring(1);
};

String.prototype.toUpperCamel = function() {
    return this.charAt(0).toUpperCase() + this.substring(1);
};

// -----------------------------
// Useful utilities to reconcile Python naming convention
// with Javascript naming convention
// -----------------------------
String.prototype.fromUnderscoreToCamel = function(upper) {
    var parts = this.split('_');
    // Only manipulate string if there is at least one "_"
    if (parts.length > 1) {
        // Default to lowerCamel (not UpperCamel)
        parts[0] = (upper === true) ? parts[0].toLowerCase().capitalize() : parts[0].toLowerCase();
        for (var i=1; i<parts.length; i++) {
            parts[i] = parts[i].toLowerCase().capitalize();
        }
    }
    return parts.join('');
};

String.prototype.fromCamelToUnderscore = function() {
    // Neutralize UpperCamel and lowerCamel strings
    var strArr = (this.charAt(0).toLowerCase()+this.slice(1)).split('');
    return strArr.map(function(a) {
            return (a.toLowerCase() !== a) ? '_'+a.toLowerCase() : a;
        }).join('');
};

String.prototype.el8_unescape = function() {
    return this.replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        /* We decided we don't want to to the symmetrical thing in el8_escape,
         * but we should do here in el8_unescape if &nbsp; shows up */
        .replace(/&nbsp;/g, " ");
};

String.prototype.el8_unescape_more = function() {
    // This fn will unescape a broad range of escaped entities. It uses a differenct
    // approach than the simple, limited whitelist of el8_unescape function. It strips
    // <script> and other HTML tags, then unescapes using .textContent
    //
    // See https://stackoverflow.com/questions/1147359/how-to-decode-html-entities-using-jquery
    // Also pre-stripping tags from a variant of this approach at:
    // http://stackoverflow.com/questions/5796718/html-entity-decode

    var str = this;
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');

    var element = document.createElement('textarea');
    element.innerHTML = str;
    str = element.textContent;
    element.textContent = '';
    return str;
};

String.prototype.el8_escape = function() {
    return this.replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
};

Number.prototype.isEven = function() {
    return (this % 2) === 0;
};

Array.prototype.remove = function(item) {
    var idx = this.indexOf(item); // Find the index
    if(idx !== -1) { this.splice(idx, 1); }
};

Array.prototype.simpleCopy = function() {
    return this.slice(0);
};

//#JSCOVERAGE_IF
if (!Array.prototype.map) {
    Array.prototype.map = function(fn) {
        var len = this.length;
        if (typeof fn !== "function") { throw new TypeError(); }
        var res = new Array(len);
        var thisp = arguments[1];
        for (var i=0; i<len; i++) {
            if (i in this) {
                res[i] = fn.call(thisp, this[i], i, this);
            }
        }
        return res;
    };
}

jQuery.fn.el8_closestWithAnyClass = function(list) {
    for(var i=0; i<list.length; i++) {
        var c = list[i];
        var result = $(this).closest('.'+c);
        if (result.length) {
            return result;
        }
    }
    return [];
};

jQuery.fn.focusFocus = function() {
    if ($(this).length) {
        $(this).get(0).focus();
        $(this).focus();
    }
    return this;
};

jQuery.fn.focusSelect = function(){
    $(this).focusFocus();
    $(this).trigger('select');
    return this;
};

jQuery.fn.swapClasses = function (classToRemove, classToAdd) {
    if ($(this)) {
        $(this)
            .addClass(classToAdd)
            .removeClass(classToRemove);
    }
};

Function.prototype.method = function( name, func ) {
    if( !this.prototype[name] ) {
        this.prototype[name] = func;
    }
};

String.prototype.trim = function() {
	return this.replace(/^\s+|\s+$/g,"");
};

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.cmp = function(str, caseSensitive) {
    if (caseSensitive) {
        return (this.trim() === str.trim());
    } else {
        return (this.trim().toLowerCase() === str.trim().toLowerCase());
    }
};

Array.prototype.indexOf = function(obj) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] === obj) {
            return i;
        }
    }
    return -1;
};

Array.prototype.has = function(obj) {
    return (this.indexOf(obj) >= 0);
};

Array.prototype.addArray = function(arr) {
    for( var i=0; i<arr.length; i++ ) {
        this.push( arr[i] );
    }
    return this;
};

RegExp.escape = function(text) {
    return text.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
};

/**
 * Various IE polyfills... because IE sucks.
 */
/* Protect window.console method calls, e.g. console is not defined on IE
 * unless dev tools are open, and IE doesn't define console.debug
 *
 * from http://stackoverflow.com/a/13817235
 */
(function() {
    if (!window.console) {
        window.console = {};
    }
    // union of Chrome, FF, IE, and Safari console methods
    var m = [
        "log", "info", "warn", "error", "debug", "trace", "dir", "group",
        "groupCollapsed", "groupEnd", "time", "timeEnd", "profile", "profileEnd",
        "dirxml", "assert", "count", "markTimeline", "timeStamp", "clear"
    ];
    // define undefined methods as noops to prevent errors
    for (var i = 0; i < m.length; i++) {
        if (!window.console[m[i]]) {
            window.console[m[i]] = function() {};
        }
    }
})();

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
// but altered slightly to pass the linter
if (!Array.prototype.forEach)
{
  Array.prototype.forEach = function(fun /*, thisArg */)
  {
    "use strict";

    if (this === void 0 || this === null) { throw new TypeError(); }

    var t = new Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw new TypeError(); }

    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      if (i in t) {
        fun.call(thisArg, t[i], i, t);
      }
    }
  };
}
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
// but altered slightly to pass the linter
if (!Array.prototype.filter)
{
  Array.prototype.filter = function(fun /*, thisArg */)
  {
    "use strict";

    if (this === void 0 || this === null) { throw new TypeError(); }

    var t = new Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function") { throw new TypeError(); }

    var res = [];
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      if (i in t)
      {
        var val = t[i];

        // NOTE: Technically this should Object.defineProperty at
        //       the next index, as push can be affected by
        //       properties on Object.prototype and Array.prototype.
        //       But that method's new, and collisions should be
        //       rare, so use the more-compatible alternative.
        if (fun.call(thisArg, val, i, t)) { res.push(val); }
      }
    }

    return res;
  };
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
